import React, { Component } from 'react';
import Style from './index.less';
import './index.less';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Checkbox from '@tencent/dui/lib/components/Checkbox';


let MemberListElementType = {
    InMeeting: 0,
    OutMeeting: 1,
    Master: 2,
    Tip: 3,
    Other: 4,
    AddNew: 5,
};

export default class LiveMemberDialog extends Component {

    constructor(props) {
        super(props);
        
        this.liveManager = this.props.liveDelegate;
        this.meetingManager = this.props.meetingDelegate;
        this.state = {
            allowFlip: this.liveManager.allowFlip(),
            visible: false,
            toastText: '',
            type: 'success',
            allMute: false,
            memberList: [],
            memberCount: 0,
        };
        this.snackTimer = 0;
    }

    componentDidMount() {
        let confmsg = this.liveManager.liveInfo.confmsg && JSON.parse(this.liveManager.liveInfo.confmsg);
        let allMute =  confmsg && confmsg.allMute || false;
        let memberList = this.liveManager.memberList || [];
        memberList = this.arrangeList(memberList);
        this.setState({
            allMute: allMute,
            memberList: memberList,
            memberCount: this.liveManager.memberCount,
        });
    }

    userChange(userList) {
        let memberList = this.arrangeList(userList);
        this.setState({
            memberList: memberList,
            memberCount: this.liveManager.memberCount,
        });
    }
    
    handleSnackbarClose = () => {
        this.setState({ visible: false });
    }

    arrangeList = (userList) => {
        let showList = [];
        let master = [];
        let inm = [];
        let outm = [];
        let meetingList = this.meetingManager && this.meetingManager.getUserInfoList() || [];
        let masterName = this.liveManager.masterName;
        userList.forEach(e => {
            let inMeeting = false;
            let toid = e.toid;
            let name = e.name;
            meetingList.forEach(m => {
                if (m.nick === name || m.toid === toid) inMeeting = true;
            });
            if (name === masterName) {
                e.name = '(正在演示)' + e.name;
                e.userType = MemberListElementType.Master;
            }
            if (e.userType === MemberListElementType.Master) {
                !master.length && master.push(e);
            } else {
                if (inMeeting) {
                    e.userType = MemberListElementType.InMeeting;
                    let stamp = true;
                    inm.forEach(elem => {
                        if (elem && elem.uid && elem.uid === e.uid) stamp = false;
                    });
                    stamp && inm.push(e);
                } else {
                    e.userType = MemberListElementType.OutMeeting;
                    let stamp = true;
                    outm.forEach(elem => {
                        if (elem && elem.uid && elem.uid === e.uid) stamp = false;
                    });
                    stamp && outm.push(e);
                }
            }
        });

        let anonymous = this.liveManager.memberCount - master.length - inm.length - outm.length;
        // let needTips = inm.length && (outm.length || anonymous > 0);
        inm.length && showList.push({
            userType: MemberListElementType.Tip,
            name: '正在语音讨论',
            uid: '-11',
        });
        showList = showList.concat(master);
        showList = showList.concat(inm);
        inm.length && (outm.length || anonymous > 0) && showList.push({
            userType: MemberListElementType.Tip,
            name: '未加入讨论',
            uid: '-12',
        });
        showList = showList.concat(outm);
        anonymous > 0 && showList.push({
            name: `${anonymous}名观众`,
            uid: '-1',
            toid: '-1',
            userPic: './img/audience.svg',
            isMute: true,
            userType: MemberListElementType.Other,
        });
        showList.push({
            name: '邀请好友',
            uid: '-2',
            toid: '-2',
            userPic: './img/invite.svg',
            isMute: true,
            userType: MemberListElementType.AddNew,
        });

        return showList;
    };

    showSnackbar = (param) => {
        this.setState({
            visible: true,
            toastText: param.message,
            type: param.type,
        });
        if (this.snackTimer !== null) {
            clearTimeout(this.snackTimer);
        }   
        this.snackTimer = setTimeout(this.handleSnackbarClose, param.duration);
    };

    onClickClose = () => {
        this.onClose('close');
    }

    onClickAddNew = () => {
        this.onClose('add-new');
    }

    onClose = (action) => {
        let state = {
            action: action,
        }
        this.props.handleCloseDialog && this.props.handleCloseDialog(state);
    }

    onCheckChanged = (value) => {
        this.setState({ allowFlip: value });
        this.props.onFlipChanged && this.props.onFlipChanged(value);
    }

    onMuteClick = (e) => {
        console.log('on mute');
        let src = event.srcElement || event.target;
        let index =  parseInt(src.getAttribute('tag'));
        let { memberList } = this.state;
        if (index < 0 || index >= memberList.length) {
            return;
        }
        this.setState({
            allMute: false,
        }, () => {
            let item = memberList[index];
            this.props.onMute && this.props.onMute(item);
        });
    }

    onAllMuteClick = () =>  {
        let { allMute } = this.state;
        this.setState({
            allMute: !allMute,
        }, () => {
            this.showSnackbar({
                message: allMute ? '已解除全场静音' : '已全场静音',
                type: 'success',
                duration: 2000,
                autoClose: true,
                closable: true,
            });
            this.props.onAllMute && this.props.onAllMute(!allMute);
        });
    }
    
    renderUserMode (item) {
        switch (item.userType) {
            case MemberListElementType.Master:
            case MemberListElementType.InMeeting:
            case MemberListElementType.OutMeeting:
                return (
                    <div className={'user-info-container-member ' + Style['user-info-container-member']}>
                        <div className={'user-face-container-member ' + Style['user-face-container-member']} >
                            <img className={'user-face-member ' + Style['user-face-member']} src={item.userPic} />
                        </div>
                        <div className={'user-nickName-member ' + Style['user-nickName-member']} >
                            {item.name}
                        </div>
                    </div>
                );
            case MemberListElementType.Other:
                return (
                    <div className={'user-info-container-member ' + Style['user-info-container-member']}>
                        <div className={'user-face-container-member ' + Style['user-face-container-member']} >
                            <div className={'audience-member ' + Style['audience-member']}/>
                        </div>
                        <div className={'user-nickName-member ' + Style['user-nickName-member']} >
                            {item.name}
                        </div>
                    </div>
                );
            case MemberListElementType.AddNew:
                return (
                    <div className={'user-info-container-member ' + Style['user-info-container-member']}>
                        <div className={'user-face-container-member ' + Style['user-face-container-member']} >
                            <div className={'addNew-member ' + Style['addNew-member']} style={{ cursor: 'pointer' }}/>
                        </div>
                        <div className={'user-nickName-member ' + Style['user-nickName-member']} >
                            {item.name}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }
    
    render() {
        
        let checkStye = {
            fontSize:'16px',
        }
        const { visible, type, toastText, allMute, memberList, memberCount } = this.state;
        let audienceNum = `参与成员(${memberCount})`;

        let list = memberList.map((item, index) => {

            let isTip = item.userType === MemberListElementType.Tip;
            let isInvite = item.userType === MemberListElementType.AddNew;
            let isMute = allMute || item.isMute;

            return (
                <li key={item.uid} style={{ height: isTip ? '32px' : '44px' }}>
                    {
                        isTip ? 
                        <div className={'user-info-tip-member ' + Style['user-info-tip-member']}>{item.name}</div>
                        :
                        <div onClick={ isInvite ? this.onClickAddNew : null} style={{
                            width: '100%',
                            height: '100%'
                        }}>
                            {this.renderUserMode(item)}
                            {this.props.hideMute || item.userType !== MemberListElementType.InMeeting ? null :
                                <div className={'user-audioIcon-container-member ' + Style['user-audioIcon-container-member']}>
                                <div tag={index} className={isMute ? 'user-audioIcon-mute-member ' + Style['user-audioIcon-mute-member'] : 'user-audioIcon-member ' + Style['user-audioIcon-member'] 
                                    } onClick={this.onMuteClick.bind(this)}>
                                </div>
                            </div>
                            }
                        </div>
                    }
                </li>
            );
        });

        return (
            <Snackbar.Container className={'dialog-wrapper-member ' + Style['dialog-wrapper-member'] + ' bubble-member ' + Style['bubble-member'] + ' top-member ' + Style['top-member']}>
                <Snackbar closable
                    onClose={this.handleSnackbarClose}
                    type={type}
                    visible={visible}
                >{toastText}</Snackbar>
                {/* <div className={'top-tip-member ' + Style['top-tip-member']} /> */}
                <div className={'member-num-member ' + Style['member-num-member']} >{audienceNum}</div>
                <button aria-label="Close" className={'modal-close-member ' + Style['modal-close-member']} onClick={this.onClickClose}><span className={'modal-close-x-member ' + Style['modal-close-x-member']}></span></button>

                <div className={'modal-content-member ' + Style['modal-content-member']}>
                    <div className={'member-list-container-member ' + Style['member-list-container-member']}>
                        <ul className={'member-list-member ' + Style['member-list-member']}>
                            {list}
                        </ul>
                    </div>
                    <div>
                        {this.props.hideMute ? null : 
                            <button className={'white-button-member ' + Style['white-button-member']} type="default" onClick={this.onAllMuteClick}>{ allMute ? '解除全场静音' : '全场静音'} </button>
                        }
                        {this.props.hideAllowFlip ? null :
                            <div className={'div-check-member ' + Style['div-check-member']}>
                                <Checkbox
                                    checked={this.state.allowFlip}
                                    onChange={this.onCheckChanged} style={checkStye}>允许观看者翻看文档全文</Checkbox>
                            </div>
                        }
                    </div>
                </div>
            </Snackbar.Container>
        );
    }
}